export const viewFeedbackAnswerState = {
    isLoading: false,
    answerList: [],
    alarmReceiverList:[],
    errorCode: 0,
    messageLabel: '',    
    statusCode: 0
}